import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Organization } from '../shared/models/organization.model';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {

  public organizationTypeSubject: Subject<number> = new Subject();

  constructor(private _http: HttpClient) { }

  /**
   * getOrganizations
   */
  public getOrganizations() {
    return this._http.get<[Organization]>(environment.serverUrl + 'organization/getByAccount').pipe(
      map(responseData => {
        const organizationsArray: Organization[] = [];
        for (const key in responseData) {
          if (responseData.hasOwnProperty(key)) {
            organizationsArray.push({ ...responseData[key] });
          }
        }
        return organizationsArray;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public getOrganization(orgId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId);
    return this._http.get<Organization>(environment.serverUrl + 'organization/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        localStorage.setItem('orgId', responseData.organizationTypeId.toString());
        this.organizationTypeSubject.next(responseData.organizationTypeId);
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * submitOrganizationUpdate
   */
  public submitOrganizationUpdate(organization: Organization) {
    return this._http
      .post<{ id: number }>(
        environment.serverUrl + 'organization/update',
        { 'organization': organization }
      ).pipe(
        map(responseData => {
          return responseData;
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }

  /**
   * submitOrganizationImage
   */
  public submitOrganizationImage(file: File, fileName: string, orgId: number) {
    const formData = new FormData();
    formData.append('id', orgId.toString());
    formData.append('imageName', fileName);
    formData.append('image', file, file.name);
    return this._http.post<any>(
      environment.serverUrl + 'organization/upload',
      formData
    ).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }



  /**
   * deleteImage
   */
  public deleteImage(orgId: string) {
    return this._http.post<void>(
      environment.serverUrl + 'organization/removeImage',
      { id: orgId }
    ).pipe(
      map(() => {
        return true;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
